import React from 'react';
import { useFormContext } from 'react-hook-form';
import CustomSwitchButton from 'components/base/CustomSwitchButton';
import './MaintenanceGeneral.scss';

const MaintenanceGeneral = () => {
  const { watch, setValue } = useFormContext();

  const activeField = "active";
  const displayHourField = "displayHour";
  const displayMinuteField = "displayMinute";
  const displayStartActiveTimeField = "displayStartActiveTime";

  const active = watch(activeField);
  const displayHour = watch(displayHourField);
  const displayMinute = watch(displayMinuteField);
  const displayStartActiveTime = watch(displayStartActiveTimeField);

  return (
    <>
      <div className="first-section-title">TURN ON NOW</div>
      <div className='maintenance-general-switch-button'>
        <CustomSwitchButton
          defaultChecked={active}
          onChange={(isChecked) => {
            setValue(activeField, isChecked, { shouldDirty: true });
          }}
        />
      </div>
      {
        displayStartActiveTime && (
          <label className="tips-message">
            {`Maintenance mode has been turned for ${displayHour}h and ${displayMinute}m (start time: ${displayStartActiveTime}.`}
          </label>
        )
      }
    </>
  );
}

export default MaintenanceGeneral;
